<div class="add-lingerie-modal">
	<h2>Réactiver une ou des lingeries :</h2>
	<form [formGroup]="form" class="flex flex-col">
		<mat-form-field>
			<mat-label>Lingeries à réactiver</mat-label>
			<mat-select formControlName="lingerie" multiple>
				<mat-option *ngFor="let lingerie of lingeries" [value]="lingerie.id">{{lingerie.libelle}}</mat-option>
			</mat-select>
			<mat-error *ngIf="form.hasError('required',['lingerie'])">Au moins une lingerie est requise</mat-error>
		</mat-form-field>
		<div mat-dialog-actions>
			<button mat-raised-button (click)="refuse()">Annuler</button>
			<button mat-raised-button color="primary" (click)="onSubmit()">Réactiver</button>
		</div>
	</form>
</div>